export default __webpack_public_path__ + "static/media/close-all-files.e09612d0.svg";